// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1193":"0b76cf31","1355":"c8637245","1803":"6dce015f","3879":"c8637245","4654":"98b007d5"}[chunkId] + ".chunk.css";
};